"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consent = void 0;
const get_1 = require("./get");
const get_all_1 = require("./get-all");
const get_all_checkboxes_1 = require("./get-all-checkboxes");
const get_purposes_1 = require("./get-purposes");
const send_queued_events_1 = require("./send-queued-events");
const set_1 = require("./set");
const set_all_1 = require("./set-all");
const set_all_checkboxes_1 = require("./set-all-checkboxes");
const set_checkboxes_1 = require("./set-checkboxes");
exports.consent = {
    get: get_1.get,
    set: set_1.set,
    getAll: get_all_1.getAll,
    setAll: set_all_1.setAll,
    getPurposes: get_purposes_1.getPurposes,
    getAllCheckboxes: get_all_checkboxes_1.getAllCheckboxes,
    setCheckboxes: set_checkboxes_1.setCheckboxes,
    setAllCheckboxes: set_all_checkboxes_1.setAllCheckboxes,
    sendQueuedEvents: send_queued_events_1.sendQueuedEvents,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY29uc2VudC9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSwrQkFBNEI7QUFDNUIsdUNBQW1DO0FBQ25DLDZEQUF3RDtBQUN4RCxpREFBNkM7QUFDN0MsNkRBQXdEO0FBQ3hELCtCQUE0QjtBQUM1Qix1Q0FBbUM7QUFDbkMsNkRBQXdEO0FBQ3hELHFEQUFpRDtBQUVwQyxRQUFBLE9BQU8sR0FBRztJQUNyQixHQUFHLEVBQUgsU0FBRztJQUNILEdBQUcsRUFBSCxTQUFHO0lBQ0gsTUFBTSxFQUFOLGdCQUFNO0lBQ04sTUFBTSxFQUFOLGdCQUFNO0lBQ04sV0FBVyxFQUFYLDBCQUFXO0lBQ1gsZ0JBQWdCLEVBQWhCLHFDQUFnQjtJQUNoQixhQUFhLEVBQWIsOEJBQWE7SUFDYixnQkFBZ0IsRUFBaEIscUNBQWdCO0lBQ2hCLGdCQUFnQixFQUFoQixxQ0FBZ0I7Q0FDakIsQ0FBQyJ9